'use client'

import { useEffect, useRef, useState } from 'react'
import { motion } from "motion/react";
import { container, item } from "@/lib/framer";
import Image from "next/image";
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

interface ImageResource {
  public_id: string; 
  secure_url: string;
}

export const Gallery = () => {



    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    // const [currentImage, setCurrentImage] = useState<ImageResource | null>(null);
    const constraintsRef = useRef<HTMLDivElement>(null);

    const [images, setImages] = useState<ImageResource[]>([]);

    useEffect(() => {
      const fetchImages = async () => {
        try {
          const response = await fetch('/api/photos');
          const data = await response.json();
          setImages(data);
        } catch (error) { 
          console.error('Error fetching images:', error);
        }
      };
  
      fetchImages();
    }, []);

    // console.log('imagesssss', images);
    
  return (
    <section id="gallery" className="py-16 md:py-24 bg-muted">
          <div className="container mx-auto px-4">
            <motion.div
              className="mb-12 text-center"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              variants={container}
            >
              <motion.h2 className="text-3xl font-bold tracking-tight sm:text-4xl" variants={item}>
                School Gallery
              </motion.h2>
              <motion.p className="mt-4 text-muted-foreground" variants={item}>
                Glimpses of our vibrant school life and activities
              </motion.p>
            </motion.div>

            <motion.div
              className="grid grid-cols-2 md:grid-cols-4 gap-4"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
              variants={container}
              ref={constraintsRef}
            >
              {images.map((image, index) => (
                <motion.div
                  key={index}
                  className="relative aspect-square overflow-hidden rounded-lg cursor-pointer"
                  variants={item}
                  whileHover={{
                    scale: 1.05,
                    zIndex: 1,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                  }}
                  onClick={() => setSelectedImage(image.secure_url)}
                  drag
                  dragConstraints={constraintsRef}
                >
                  <Image
                    src={image.secure_url || "/placeholder.svg"}
                    alt={`School activity ${index + 1}`}
                    fill
                    className="object-cover transition-transform duration-300 hover:scale-110"
                  />
                </motion.div>
              ))}
            </motion.div>

            {/* Lightbox */}
            {selectedImage && (
              <motion.div
                className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setSelectedImage(null)}
              >
                <motion.div
                  className="relative max-w-4xl max-h-[80vh] w-full"
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ type: "spring", damping: 15 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="absolute top-2 right-2 z-10 bg-black/50 text-white p-2 rounded-full"
                    onClick={() => setSelectedImage(null)}
                  >
                    ✕
                  </button>
                  <div className="relative w-full h-[80vh]">
                    <Image
                      src={selectedImage || "/placeholder.svg"}
                      alt="Gallery image"
                      fill
                      className="object-contain"
                    />
                  </div>
                </motion.div>
              </motion.div>
            )}

            {/* button to navigate /gallery for more */}
            <div className="flex justify-center mt-8">
              <Link
                href="/gallery"
                className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2 text-primary transition-colors hover:text-white hover:bg-primary/80"
              >
                <span>View More</span>
                <ChevronRight className="h-4 w-4" />
              </Link>
            </div>

            {/* Gallery Navigation */}
            {/* <motion.div
              className="flex justify-center mt-8 gap-4"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
            >
              <motion.button
                className="p-2 rounded-full bg-primary/10 text-primary"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => setCurrentImage((prev) => (prev === null ? 0 : prev - 1))}
              >
                <ChevronLeft className="h-6 w-6" />
              </motion.button>
              <motion.button
                className="p-2 rounded-full bg-primary/10 text-primary"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => setCurrentImage((prev) => (prev === null ? 0 : prev + 1))}
              >
                <ChevronRight className="h-6 w-6" />
              </motion.button>
            </motion.div> */}
          </div>
        </section>
  )
}
